// import {LMSInstance} from "./config";

export const paymentApi = {
    studentPaymentStatus: async () => {
        // return await LMSInstance.get("/v1/student/studentPaymentStatus");
    },
};
